/**
 * Whether the portal monitor has given up on the cloud. The monitor lives for the page and tells
 * each new subscriber its state, so a store made during an outage shows it at once.
 *
 * A resource that must reload when the cloud answers again has a `<resource>PortalAtom` beside
 * its atoms, which `portalEventAtom` calls with every event.
 */

import { atom } from 'jotai';

import { PortalEvent } from '@/types/portal';

import { agentsPortalAtom } from './agentsAtoms';
import { devicesPortalAtom } from './devicesAtoms';
import { layoutsPortalAtom } from './layoutsAtoms';
import { liveCamerasPortalAtom } from './liveCamerasAtoms';
import { rulesPortalAtom } from './rulesAtoms';

export const portalUnavailableAtom = atom(false);

/** What the portal monitor says: the banner's flag, and each resource that reloads on it. */
export const portalEventAtom = atom(null, (_get, set, event: PortalEvent): void => {
    set(agentsPortalAtom, event);
    set(devicesPortalAtom, event);
    set(layoutsPortalAtom, event);
    set(liveCamerasPortalAtom, event);
    set(rulesPortalAtom, event);
    switch (event) {
        case PortalEvent.Unavailable:
            set(portalUnavailableAtom, true);
            break;
        case PortalEvent.Recovered:
            set(portalUnavailableAtom, false);
            break;
        default:
            break;
    }
});
